import { Link } from 'react-router-dom'
import './CTA.css'

const CTA = ({ 
  title = "¿Necesitas asesoramiento contable?",
  subtitle = "Contactanos hoy mismo y recibe una consulta personalizada",
  primaryText = "Contactar",
  primaryLink = "/contacto",
  secondaryText = "Ver Servicios",
  secondaryLink = "/servicios",
  showWhatsApp = true 
}) => {
  return (
    <section className="cta">
      <div className="container">
        <div className="cta__content">
          <div className="cta__text">
            <h2 className="cta__title">{title}</h2>
            <p className="cta__subtitle">{subtitle}</p>
          </div>
          
          <div className="cta__actions">
            <Link to={primaryLink} className="cta__button cta__button--primary">
              {primaryText}
            </Link>
            <Link to={secondaryLink} className="cta__button cta__button--secondary">
              {secondaryText}
            </Link>
            {showWhatsApp && (
              <a 
                href="https://wa.me/5491166201346" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta__button cta__button--whatsapp"
              >
                📱 WhatsApp
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
